import React from 'react';
import './contact.css';

const Contact = () => {
    return (
        <section className="contact section" id="contact">
            <h2 className="section__title">Get in touch</h2>
            <span className="section__subtitle">Contact Me</span>

            <div className="contact__container container grid">
                <div className="contact__content">


                    <div className="contact__info">
                        <div className="contact__card">
                            <i className="bx bx-mail-send contact__card-icon"></i>

                            <h3 className="contact__card-title">Email</h3>
                            <span className="contact__card-data">adityacyan@gmail.com</span>

                            <a href="mailto:adityacyan@gmail.com" className="contact__button">
                                Write me <i className='bx bx-right-arrow-alt contact__button-icon'></i>
                            </a>
                        </div>

                        <div className="contact__card">
                            <i className="bx bxl-whatsapp contact__card-icon"></i>

                            <h3 className="contact__card-title">Whatsapp</h3>
                            <span className="contact__card-data">+91 7366915669</span>

                            <a href="https://api.whatsapp.com/send?phone=7366915669&text=Hello! I Just saw your portfolio and wanted to connect" className="contact__button">
                                Message me <i className='bx bx-right-arrow-alt contact__button-icon'></i>
                            </a>
                        </div>

                        <div className="contact__card">
                            <i className="bx bxl-linkedin contact__card-icon"></i>

                            <h3 className="contact__card-title">LinkedIn</h3>
                            <span className="contact__card-data">Aditya Raj</span>

                            <a
                                href="https://www.linkedin.com/in/adityacyan/"
                                className="contact__button"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Connect <i className='bx bx-right-arrow-alt contact__button-icon'></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
